import { type LoopStep } from '../ActionWizard/subsections/actionSectionTypes';

// A loop iterates the array variable chosen in its wizard. If that variable is
// deleted the loop has nothing to iterate, so the step is flagged in error and
// the selection is kept - marked deleted - rather than cleared, so the card can
// still name what went missing.
export const loopRemoveVariable = (
  step: LoopStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];
  const arrayVariable = step.details?.forEachItem?.arrayVariable;

  if (arrayVariable?.value === variableName) {
    const nextStep = {
      ...step,
      hasError: true,
      details: {
        ...step.details,
        forEachItem: {
          ...step.details.forEachItem,
          arrayVariable: {
            ...arrayVariable,
            deleted: true,
          },
        },
      },
    };

    if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }

    return { nextStep, nextErrorIds };
  }

  return { nextStep: step, nextErrorIds };
};
